<div class="rl-container">
  <div class="d-flex">
    <div class="field-radiobutton mb-1">
      <p-radiobutton name="roleSelection" [(ngModel)]="roleSelection" value="all" inputId="all"
        (onClick)="handleRoleTypeChange($event)" [disabled]="disableField"></p-radiobutton>
      <label class="mb-0 ml-1 mr-2" for="all">All</label>
    </div>
    <div class="field-radiobutton mb-1">
      <p-radiobutton name="roleSelection" [(ngModel)]="roleSelection" value="selected" inputId="selected"
        [disabled]="disableField" (onClick)="handleRoleTypeChange($event)"></p-radiobutton>
      <label class="mb-0 ml-1 mr-2" for="selected">Selected</label>
    </div>
  </div>
  <div *ngIf="roleSelection === 'selected'" class="mb-2  mt-2">
    <fieldset>
      <legend>Select</legend>
      <vb-checkbox-group [(ngModel)]="selectedRoles" (change)="handleCheckboxChange($event)">
        <vb-checkbox *ngFor="let role of allRoles" [value]="role.sid" [option]="role.shortName"
          [disableField]="disableField || ((element.name === 'accessControl'|| element.name ==='t_importProps') && role.shortName === 'App Admin') ">
        </vb-checkbox>
      </vb-checkbox-group>
    </fieldset>
    <!-- <p-fieldset [toggleable]="true">
      <ng-template pTemplate="header">
          <div class="flex align-items-center">
              <span class="pi pi-user mr-2"></span>
              <span class="font-bold">Select</span>
          </div>
      </ng-template>
      <checkbox-group [(ngModel)]="selectedRoles" (change)="handleCheckboxChange($event)">
        <checkbox *ngFor="let role of allRoles" [value]="role.sid" [option]="role.shortName"
          [disableField]="disableField">
        </checkbox>
      </checkbox-group>
    </p-fieldset> -->

  </div>
</div>